import React, {
  useImperativeHandle,
  useRef,
  useMemo,
  forwardRef
} from "react";
import "./resources/scss/main.scss";
import LeftSection from "./components/LeftSection";
import RightSection from "./components/RightSection";
import useUserDetails from "./hooks/useUserDetails";
import useClevertap from "./hooks/useCleverTap";
import { MIDDLEWARE } from "./utils/utils";
import SearchBar from "./components/SearchBar";

interface IProps {
  userData?: any;
  middleware?: string;
  environment: string;
  page_name: string;
  page: string;
  cooldown_time?: number;
  extra_params?: any;
  isClevertapOn: boolean;
  showBetaTag?: boolean;
  containerStyles?: React.CSSProperties;
  containerClasses?: string;
  subContainerStyles?: React.CSSProperties;
  subContainerClasses?: string;
  isRecallGetUser?: boolean;
  isMobileViewEnabled?: boolean;
  isLoggedIn?: boolean;
  hideQuickSearch?: boolean;
  handleEventListener?:({action, payload, page}:{action:string, payload?: any,page:string})=>void;
  showDrawer?: boolean; // temporary prop to control drawer display
}

const RecruiterHeader = forwardRef<any, IProps>((props, ref) => {
  const {
    userData,
    isRecallGetUser,
    middleware,
    environment,
    isClevertapOn,
    page_name,
    page,
    containerStyles,
    containerClasses,
    subContainerStyles,
    subContainerClasses,
    extra_params,
    showBetaTag,
    isMobileViewEnabled,
    isLoggedIn,
    hideQuickSearch,
    handleEventListener,
    showDrawer = true
  } = props;

  const isClient = typeof window !== "undefined";

  const { userDetails } = useUserDetails({
    isRecallGetUser,
    isClient,
    middleware : middleware || MIDDLEWARE,
    page_name,
  });

  const isRevamp = useMemo(() => {
    if (typeof window === "undefined") return true;
    const isRevampValue = localStorage?.getItem("isRevamp");
    return isRevampValue !== null ? isRevampValue === "true" : true;
  }, []);

  const effectiveUser = userData || userDetails;

  useClevertap({
    environment,
    extra_params,
    isClevertapOn,
    isClient,
    page_name,
    userData: effectiveUser,
  });

  const navDownloadIconRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getDownloadIconElement: () => navDownloadIconRef.current,
  }));

  if (effectiveUser === undefined) return null;

  return (
    <div
      className={`rec_header_wrapper ${containerClasses ?? ""}`}
      style={containerStyles}
    >
      <div
        className={`rec_header_container ${
          !userData?.recruiter_id && !userDetails?.recruiter_id
            ? "rec_header_logout_wrapper"
            : ""
        } ${subContainerClasses ?? ""}`}
        style={subContainerStyles}
      >
        <LeftSection
          userData={effectiveUser}
          showBetaTag={showBetaTag}
          isMobileViewEnabled={isMobileViewEnabled}
          isRevamp={isRevamp}
          isLoggedIn={isLoggedIn}
        />

        {!hideQuickSearch && (
          <SearchBar
            middleware={middleware || MIDDLEWARE}
            userDetails={userDetails}
            isClient={isClient}
            handleEventListener={handleEventListener}
            page={page}
          />
        )}
        <RightSection
          middleware={middleware || MIDDLEWARE}
          userData={
            isLoggedIn && !effectiveUser
              ? { recruiter_id: "1", username: "" }
              : effectiveUser
          }
          navDownloadIconRef={navDownloadIconRef}
          showDrawer={showDrawer}
        />
      </div>
    </div>
  );
});

export default RecruiterHeader;
